import React, { ReactNode } from 'react';
import { connect } from 'react-redux';

import { showModal } from 'store/main/ducks/modal';

type OwnProps = {
  type: 'warning' | 'danger';
  title?: string;
  buttonText: string;
  body: ReactNode;
  onConfirm: () => Promise<unknown>;
  render: (arg0: { showModal: () => void }) => ReactNode;
  'data-qa-id'?: string;
};
type Props = OwnProps & {
  showModal: typeof showModal;
};
type State = {
  submitting: boolean;
};

class ShowConfirmationModal extends React.Component<Props, State> {
  showModal = () => {
    const { type, title, buttonText, body, onConfirm } = this.props;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    this.props.showModal('CONFIRMATION', {
      type,
      title,
      buttonText,
      body,
      onConfirm,
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      'data-qa-id': this.props['data-qa-id'],
    });
  };

  render() {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    return this.props.render({
      showModal: this.showModal,
    });
  }
}

// @ts-expect-error ts-migrate(2558) FIXME: Expected 5 type arguments, but got 6.
export default connect<Props, OwnProps, _, _, _, _>(null, {
  showModal,
})(ShowConfirmationModal);
